import type { IconSvgObject } from './types';

const HorizonalScrollPointIcon: IconSvgObject = [
  ["path", { d: "M14.0001 12C14.0001 13.1046 13.1046 14 12.0001 14C10.8955 14 10.0001 13.1046 10.0001 12C10.0001 10.8954 10.8955 10 12.0001 10C13.1046 10 14.0001 10.8954 14.0001 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.0001 8C18.0001 8 22.0001 10.946 22.0001 12C22.0001 13.0541 18.0001 16 18.0001 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.00003 16C6.00003 16 2.00007 13.054 2.00006 12C2.00005 10.9459 6.00006 8 6.00006 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HorizonalScrollPointIcon;
